import React, { useState, useEffect } from 'react'
import * as API from '../../api'
import * as authService from '../../services/auth'
import styled from 'styled-components'
import { Button, Typography } from '@material-ui/core'
import TextField from '@material-ui/core/TextField'
import CircularProgress from '@material-ui/core/CircularProgress'
import Redirect from 'react-router-dom/Redirect'
import Link from '@material-ui/core/Link';
import logo from '../../assets/images/logoNovo.png'
import { useSnackbar } from 'notistack'
const BlockContent = styled.div`
    max-width: 400px;
    width: 100%;
    padding: 0 15px;
`
const StyledForm = styled.form`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`
const LoginOptions = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    color: #43425D;
    margin: 16px 0 32px;
`
const Logo = styled.img`
    max-width: 256px;
    margin-bottom: 64px;
`
const FormLogin = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [fieldError, setFieldError] = useState(false)
  const [hasError, setHasError] = useState(false)
  const { enqueueSnackbar } = useSnackbar()
  var query = window.location.search.substring(1);

  useEffect(() => {
    emptyIputs(email, password)
  })

  useEffect(() => {
    setHasError(false)
  }, [email, password])
  
  const emptyIputs = (login, senha) => { 
    if ((login.length === 0) || (senha.length === 0)){
      return true
    } else {
      return false
    }
  }

  if(query){ //verifica se contem o token para login externo efaz o login redicerionando para o curso
    var pair = query.split("=");
    let result = Buffer.from(pair[1], 'base64').toString('ascii')
    //let stringJson = JSON.stringify(result)
    let stringObj = JSON.parse(result)
    const token = stringObj.token
    const ssoToken = stringObj.ssoToken
    const refreshToken = stringObj.refreshToken
    const cursoId = stringObj.idCurso
    const contentId = stringObj.content
    const contemTrilhas = stringObj.trilhas

    authService.login({ token, refreshToken, ssoToken })

    let pathname = '/curso/'+cursoId
    if(contentId){
       pathname = pathname +  '/'+ contentId
    }
    if(!contemTrilhas){
      pathname = '/curso/'+cursoId+'/semconteudo'
    }

    return (
      <Redirect
        to={{
          pathname: pathname,
          state: {
            fromLogin: true
          }
        }}
      />
    ) 
  }

  const validateFields = (firstField, secondField) => {
    if((firstField === '' || undefined) || (secondField === '' || undefined)){
        setFieldError(true)
        return fieldError
    } else setFieldError(false)
  }

  

  const login = (e) => {
    e.preventDefault()
    setLoading(true)
    validateFields(email, password)
    !fieldError && API.auth
        .login({
          email,
          password
        })
        .then(response => {
          const { ok, status } = response
          if (ok) {
            response
              .json()
              .then(data => {
                const { token, refreshToken, ssoToken } = data
                authService.login({ token, refreshToken, ssoToken })
                setLoading(false)
                setHasError(false)
              })
              .catch(err => {
                setLoading(false)
                if (status === 401) {
                    enqueueSnackbar('E-mail ou senha inválidos', {variant: 'error', anchorOrigin: { vertical: 'bottom', horizontal: 'right' }})
                    setHasError(true)
                } else {
                  enqueueSnackbar('Estamos com problemas, tente mais tarde.')
                }
              })
          } else {
            setLoading(false)
            if (status === 401) {
                enqueueSnackbar('E-mail ou senha inválidos', {variant: 'error', anchorOrigin: { vertical: 'bottom', horizontal: 'right' }})
                setHasError(true)
            } else {
              enqueueSnackbar('Estamos com problemas, tente mais tarde.')
            }
          }
        })
        .catch(err => {
          setLoading(false)
          enqueueSnackbar('Estamos com problemas, tente mais tarde.')
        })
  }

  if (authService.getAccessToken()) {
    return (
      <Redirect
        to={{
          pathname: '/',
          state: {
            fromLogin: true
          }
        }}
      />
    )
  }
  return (
    <BlockContent>
      <StyledForm  noValidate autoComplete="off" onSubmit={(e) => login(e)}>
        <Logo src={logo} style={{marginTop:20}} />
        <TextField autoFocus required style={{ width: '100%' }} value={email} error={!!fieldError || !!hasError} type="email" name="email" label="E-mail" onChange={(e) => setEmail(e.target.value)}/>
        <TextField required style={{ width: '100%' }} value={password} error={!!fieldError || !!hasError} type="password" name="password" label="Senha" onChange={(e) => setPassword(e.target.value)}/>
        <Button disabled={emptyIputs(email, password)} variant="contained" size="large" color="primary" type="submit">
            {loading ? <CircularProgress color={'white'} size={24}  /> 
            : <span>Entrar</span>}
        </Button>
        <LoginOptions>
            <Typography variant="body2" >
                <Link href="https://atendimento.manole.com.br/aprimora/recuperar-senha" rel="noopener" target="_blank">Esqueci minha senha</Link>
            </Typography>
        </LoginOptions>
      </StyledForm>
    </BlockContent>
  )
}
export default FormLogin